export const updateEntry = <T>(entries: T[], index: number, fn: (entry: T) => T): T[] =>
  entries.map((entry, i) => {
    if (i === index) return fn(entry);
    return entry;
  });

export default updateEntry;
